import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomAlert from "./CustomAlert";

const Logout = () => {
  const navigate = useNavigate();
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    const logoutUser = async () => {
      // Clear session storage first - this is the important part for the user
      sessionStorage.clear();
      
      // Show the alert immediately
      setShowAlert(true);
      
      // Then attempt the API logout with timeout protection
      try {
        const token = sessionStorage.getItem("token"); // This will be null now but using it for completeness
        
        // Use AbortController for timeout
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 3000); // 3 second timeout
        
        // Make API call but don't wait indefinitely
        fetch(`${process.env.REACT_APP_API_PATH}/auth/logout`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          signal: controller.signal
        }).catch(error => {
          if (error.name === 'AbortError') {
            // console.log('Logout request timed out, but user was logged out locally');
          } else {
            console.error("Logout API call failed:", error);
          }
        });
        
        // Clear the timeout if the request completes before the timeout
        clearTimeout(timeoutId);
      } catch (error) {
        console.error("Logout failed or not supported:", error);
      }
      
      // Only navigate after the alert closes - no need for a separate timer
      // Navigation is now handled by the handleCloseAlert function
    };
    
    logoutUser();
  }, [navigate]);

  const handleCloseAlert = () => {
    setShowAlert(false);
    navigate("/login", { replace: true }); // Use replace to prevent back button issues
  };

  return (
    <CustomAlert
      message="You have been successfully logged out."
      isOpen={showAlert}
      onClose={handleCloseAlert}
      autoCloseTime={3000} // Increased to 3 seconds (2x the previous value)
    />
  );
};

export default Logout;
